var commonInfo = {
  state: {
    // 当前法庭类型 default: 庭审  arbitration: 仲裁
    tribunalType: '',
    showNameMap: {
      // defendant: '被告', // 被告
      // judge: '法官', // 法官
      // plaintiff: '原告', // 原告
      // clerk: '书记员', // 书记员
      // third: '第三人', // 第三人
      // party: '当事人', // 当事人
      // agent: '代理人', // 代理人
      device: '设备',
      judge: '法官',
      clerk: '书记员',
      trior: '审判员',
      plaintiff: '原告',
      defendant: '被告',
      pagent: '原告代理人',
      dagent: '被告代理人',
      third: '第三人',
      appellant: '上诉人',
      appellee: '被上诉人',
      originalTrialPlaintiff: '原审原告',
      originalTrialDefendant: '原审被告',
      originalTrialThird: '原审第三人',
      retrialApplicant: '再审申请人',
      retrialRespondent: '再审被申请人',
      complainant: '申诉人',
      respondent: '被申诉人',
      appellantRetrial: '再审上诉人',
      retrialAppellee: '再审被上诉人',
      additionalThirdParty: '再审追加第三人',
      additionalPlaintiffRetrial: '再审追加原告',
      appellantFirst: '原审上诉人',
      appelleeOriginalTrial: '原审被上诉人',
      counterclaimPlaintiff: '反诉原告',
      counterclaimDefendant: '反诉被告',
      originalApplicant: '原审申请人',
      originalRespondent: '原审被申请人',
      plainCounterOriginalTrial: '原审反诉原告',
      plainCounterDefendant: '原审反诉被告',
      privateProsecutor: '自诉人',
      counterclaim: '反诉人',
      plainIncidentCivil: '附带民事诉讼原告人',
      defendIncidentCivil: '附带民事诉讼被告人',
      cplainIncidentCivil: '附带民事诉讼反诉原告',
      cDefendIncidentCivil: '附带民事诉讼反诉被告',
      oPlainIncidentCivil: '原审附带民事诉讼原告',
      oDefendIncidentCivil: '原审附带民事诉讼被告',
      applicantReconsideration: '申请复议人',
      stakeholdersOriginal: '原审利害关系人',
      criminalSuspect: '犯罪嫌疑人',
      defendCountOriginal: '原审反诉被告人',
      originaler: '原审反诉人'
    },
    maxFileSize: 0
  },
  mutations: {
    SET_COMMONINFO: function SET_COMMONINFO(state, common) {
      state.tribunalType = common.tribunalType;
      state.showNameMap = common.showNameMap;
      state.maxFileSize = common.maxFileSize || 1024 * 1024;
    }
  },
  actions: {
    SetCommonInfo: function SetCommonInfo(_ref, common) {
      var commit = _ref.commit;
      commit('SET_COMMONINFO', common);
    }
  }
};
export default commonInfo;